import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { FontLoader } from "three/addons/loaders/FontLoader.js";
import { TextGeometry } from "three/addons/geometries/TextGeometry.js";

THREE.ColorManagement.enabled = false;

const params = {
  color: 0xffffff,
  transmission: 1,
  opacity: 1,
  metalness: 0.0,
  roughness: 0.0,
  ior: 1.52,
  thickness: 0.1,
  specularIntensity: 1,
  specularColor: 0xffffff,
  lightIntensity: 1,
  exposure: 1,
};

/**
 * Base
 */
// Canvas
const canvas = document.querySelector(".webgl1");
const canvas2 = document.querySelector(".webgl2");

// Scene
const scene = new THREE.Scene();
const scene2 = new THREE.Scene();
const hdrEquirect = new RGBELoader().load(
  "https://dl.polyhaven.org/file/ph-assets/HDRIs/hdr/1k/satara_night_1k.hdr",
  function () {
    hdrEquirect.mapping = THREE.EquirectangularReflectionMapping;
  }
);

scene.environment = hdrEquirect;
scene2.environment = hdrEquirect;

const textureLoader = new THREE.TextureLoader();
const matcapTexture = textureLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-park-3d@main/dist/textures/matcaps/Diamond/27.png"
);

const material = new THREE.MeshPhysicalMaterial({
  //color: params.color,
  metalness: params.metalness,
  roughness: params.roughness,
  ior: params.ior,
  transmission: params.transmission,
  specularIntensity: params.specularIntensity,
  specularColor: params.specularColor,
  opacity: params.opacity,
  side: THREE.DoubleSide,
  //transparent: true,
  color: "white",
  //clearcoat: 1,
  //reflectivity: 0,
});

const material2 = new THREE.MeshMatcapMaterial({ matcap: matcapTexture });

/**
 * Loader
 */
const dracoLoader = new DRACOLoader();
dracoLoader.setDecoderPath(
  "https://cdn.jsdelivr.net/npm/three@0.153.0/examples/jsm/libs/draco/"
);

const gltfLoader = new GLTFLoader();
gltfLoader.setDRACOLoader(dracoLoader);

/**
 *
 * Models
 */

let cd = new THREE.Object3D();
let internet = new THREE.Object3D();
let id = new THREE.Object3D();
let group = new THREE.Group();

gltfLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-obj-main@main/dist/cd-2.glb",
  (gltf) => {
    cd = gltf.scene;

    cd.scale.set(0.01, 0.01, 0.01);
    cd.position.set(0, 0, 0.1);
    let cdObj = cd.getObjectByName("imagetostl_mesh0");
    cdObj.material = material;
    // cd.rotation.y = 1.25;
    scene.add(cd);
    //randomMovement();
  }
);

gltfLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-obj-main@main/dist/internet.glb",
  (gltf) => {
    internet = gltf.scene;

    internet.scale.set(0.01, 0.01, 0.01);
    internet.position.set(0, -0.05, -0.01);
    internet.rotation.x = 1.5;
    let iObj = internet.getObjectByName("imagetostl_mesh0");
    iObj.material = material;
    // cd.rotation.y = 1.25;
    group.add(internet);
  }
);

gltfLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-obj-main@main/dist/id.glb",
  (gltf) => {
    id = gltf.scene;

    id.scale.set(0.01, 0.01, 0.01);
    id.position.set(0, 0, 0.1);
    let idObj = id.getObjectByName("imagetostl_mesh0");
    idObj.material = material;
    id.rotation.set(0, 1, 1);
    scene.add(id);
  }
);

/**
 * Fonts
 */
const fontLoader = new FontLoader();
let text, text2, text3;

fontLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-park-3d@main/dist/fonts/Iskry.json",
  async (font) => {
    //const material2 = new THREE.MeshMatcapMaterial({ matcap: matcapTexture });
    const textGeometry = new TextGeometry("3", {
      font: font,
      size: 0.2,
      height: 0.01,
      curveSegments: 24,
    });
    textGeometry.center();
    text = new THREE.Mesh(textGeometry, material);
    group.add(text);
    scene.add(group);

    const textGeometry2 = new TextGeometry("AP", {
      font: font,
      size: 1,
      height: 1 * 0.15,
      curveSegments: 24,
      bevelEnabled: true,
      bevelThickness: 0.01,
      bevelSize: 0.02,
      bevelOffset: 0,
      bevelSegments: 5,
    });
    textGeometry2.center();
    text2 = new THREE.Mesh(textGeometry2, material2);
    text2.position.z = 2;
    scene2.add(text2);
  }
);

gltfLoader.load(
  "https://cdn.jsdelivr.net/gh/theNkennaAmadi/amber-obj-main@main/dist/kfont.glb",
  (gltf) => {
    text3 = gltf.scene;

    text3.scale.set(0.25, 0.25, 0.25);
    //text3.position.set(0, 0, 0);
    let tObj = text3.getObjectByName("Text");
    tObj.material = material;
    //id.rotation.set(0, 1, 1);
    scene.add(text3);
  }
);

/**
 * Sizes
 */
const sizes = {
  width: window.innerWidth,
  height: window.innerHeight,
};

const sizes2 = {
  width: document.querySelector(".obj-canvas-wrapper").clientWidth,
  height: document.querySelector(".obj-canvas-wrapper").clientHeight,
};

window.addEventListener("resize", () => {
  // Update sizes
  sizes.width = window.innerWidth;
  sizes.height = window.innerHeight;

  sizes2.width = document.querySelector(".obj-canvas-wrapper").clientWidth;
  sizes2.height = document.querySelector(".obj-canvas-wrapper").clientHeight;

  //console.log(numericSize);

  //console.log(text2.geometry.parameters.options.size);

  // Update camera
  camera.aspect = sizes.width / sizes.height;
  camera.updateProjectionMatrix();

  //camera2.lookAt(text2.position);
  //camera2.position.set(0, 0, 4 / (sizes2.width / 1000));
  camera2.aspect = sizes2.width / sizes2.height;
  camera2.updateProjectionMatrix();

  // Update renderer
  renderer.setSize(sizes.width, sizes.height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

  renderer2.setSize(sizes2.width, sizes2.height);
  renderer2.setPixelRatio(Math.min(window.devicePixelRatio, 2));
});

//const ambientLight = new THREE.AmbientLight("white", 1);
//scene.add(ambientLight);

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(
  75,
  sizes.width / sizes.height,
  0.1,
  100
);
//camera.position.z = 6
camera.position.set(0, 0, 1.1);
scene.add(camera);

const camera2 = new THREE.PerspectiveCamera(
  100,
  sizes2.width / sizes2.height,
  1,
  2000
);
//
//camera2.position.set(0, 0, 4 / (sizes2.width / 1000));
scene2.add(camera2);

//const controls = new OrbitControls(camera, canvas);
//controls.enabled = true;

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
  canvas: canvas,
  alpha: true,
  antialias: true,
  powerPreference: "high-performance",
});
renderer.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

const renderer2 = new THREE.WebGLRenderer({
  canvas: canvas2,
  alpha: true,
  antialias: true,
  powerPreference: "high-performance",
});
renderer2.outputColorSpace = THREE.LinearSRGBColorSpace;
renderer2.setSize(sizes2.width, sizes2.height);
renderer2.setPixelRatio(Math.min(window.devicePixelRatio, 2));

/**
 * Animate
 */
const clock = new THREE.Clock();

const tick = () => {
  const elapsedTime = clock.getElapsedTime();

  //controls.update();
  if (cd) {
    cd.position.x = Math.sin(elapsedTime) * 0.1 + 0.1 * (sizes.width / 1000);
    cd.rotation.z = Math.cos(elapsedTime);
    cd.rotation.x = Math.cos(elapsedTime);
    cd.position.y = Math.sin(elapsedTime) * 0.1 + 0.4 * (sizes.height / 1000);
  }

  if (group) {
    group.position.x =
      Math.cos(elapsedTime - 0.1) * 0.1 - 0.8 * (sizes.width / 1000);
    group.rotation.x = Math.sin(elapsedTime);
    group.rotation.y = Math.cos(elapsedTime);
    //group.position.y = Math.sin(elapsedTime - 0.1) * 0.1 - 0.3;
  }

  if (id) {
    id.position.x = Math.cos(elapsedTime) * 0.1 + 0.65 * (sizes.width / 1000);
    id.rotation.z = Math.cos(elapsedTime);
    id.position.y = Math.sin(elapsedTime) * 0.1 - 0.45 * (sizes.height / 1000);
  }

  if (text3) {
    text3.position.x = Math.cos(elapsedTime) * 0.1 + 0.9 * (sizes.width / 1000);
    text3.rotation.z = Math.cos(elapsedTime);
    text3.rotation.y = Math.sin(elapsedTime);
    text3.position.y = Math.sin(elapsedTime) * 0.1 * (sizes.height / 1000);
  }

  if (text2) {
    text2.rotation.y = elapsedTime;
    camera2.lookAt(text2.position);
  }

  // Render
  renderer.render(scene, camera);
  renderer2.render(scene2, camera2);

  // Call tick again on the next frame
  window.requestAnimationFrame(tick);
};

tick();
